import { ResponseType, PaginationResponseType } from 'types/response.d';
import { ForceChangePassword, UserType } from 'types/entities/users.d';
import { UserCriteria } from 'types/models/users.d';
import { get, post, put } from './axios';

const url = `/users`;
const registerUrl = `/v1/ext/register`;

export interface ClientRegisterRequest {
  registerMethod: 'EMAIL' | 'PHONE';
  name?: string;
  email?: string;
  phoneNumber?: string;
  password: string;
  confirmPassword: string;
  userLocale: string;
}

export interface PhoneOtpVerifyRequest {
  phoneNumber: string;
  otpCode: string;
}

export interface EmailOtpVerifyRequest {
  email: string;
  otpCode: string;
}

export interface PhoneOtpResponse {
  success: boolean;
  message: string;
  attemptsRemaining?: number;
}

export const getById = (id: number): Promise<ResponseType<UserType>> => get(`${url}/${id}`);

export const filter = (request: UserCriteria): Promise<PaginationResponseType<UserType[]>> =>
  get(url, { params: { ...request } });

export const update = (id: number, request: UserType): Promise<ResponseType<UserType>> =>
  put(`${url}/${id}`, request);

export const create = (request: UserType): Promise<ResponseType<UserType>> => post(url, request);

export const createMember = (request: UserType): Promise<ResponseType<UserType>> =>
  post(registerUrl, request);

export const registerClient = (request: ClientRegisterRequest): Promise<ResponseType<UserType>> =>
  post(registerUrl, request);

export const verifyPhoneRegistrationOtp = (
  request: PhoneOtpVerifyRequest
): Promise<ResponseType<PhoneOtpResponse>> => post(`${registerUrl}/phone/verify`, request);

export const verifyEmailRegistrationOtp = (
  request: EmailOtpVerifyRequest
): Promise<ResponseType<PhoneOtpResponse>> => post(`${registerUrl}/email/verify`, request);

export const checkEmailAvailability = (email: string): Promise<ResponseType<boolean>> =>
  get(`${url}/check-email-availability`, { params: { email } });

export const forceChangePassword = (
  request: ForceChangePassword
): Promise<ResponseType<UserType>> =>
  put(`${url}/${request.id}/force-change-password`, {
    password: request.password,
    confirmPassword: request.confirmPassword,
  });
